"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("react"),
  t = require("prop-types"),
  n = require("./taggedTemplateLiteral-97b463ad.js"),
  r = require("styled-components"),
  a = require("polished/lib/helpers/rem"),
  o = require("./typography-fb2881fe.js");
function i(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var l,
  d,
  s = i(e),
  p = i(t),
  u = i(r),
  f = i(a),
  c = u["default"](o.TypographyComponent)(l || (l = n._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.centeredLine,
      o = f["default"](-7);
    return a && (o = f["default"](-12)), r.css(d || (d = n._taggedTemplateLiteral(["\n    display: flex;\n    align-items: flex-end;\n    padding-bottom: 0;\n    margin-bottom: 0;\n    color: ", ";\n    text-transform: uppercase;\n\n    /** The border */\n    ::after {\n      content: '';\n      flex: 1;\n      width: 100%;\n      position: relative;\n      top: ", ";\n      border-bottom: 1px solid ", ";\n      margin-left: ", "\n    }\n  "])), t.colors.neutral.grayDark10, o, t.colors.neutral.grayDark10, f["default"](10));
  }),
  m = function m(e) {
    var t = e.centeredLine,
      n = e.className,
      r = e.headingText;
    return s["default"].createElement(c, {
      className: n,
      component: "h3",
      variant: "h6",
      centeredLine: t
    }, r);
  };
m.propTypes = {
  centeredLine: p["default"].bool,
  className: p["default"].string,
  headingText: p["default"].oneOfType([p["default"].string, p["default"].object]).isRequired
}, exports.HeadingWithLineComponent = m;